<template>
  <div class="vip-order-list">
    <el-card>
      <template slot="header">
        <div class="card-header">
          <span>VIP订单管理</span>
        </div>
      </template>
      <el-table :data="orderList" style="width: 100%">
        <el-table-column prop="id" label="订单ID" min-width="80" />
        <el-table-column prop="user_id" label="用户ID" min-width="80" />
        <el-table-column prop="order_no" label="订单号" min-width="180" />
        <el-table-column prop="amount" label="金额" min-width="80">
          <template slot-scope="scope">
            ¥{{ scope.row.amount / 100 }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="80">
          <template slot-scope="scope">
            {{ getOrderStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column prop="payment_method" label="支付方式" min-width="100">
          <template slot-scope="scope">
            {{ getPaymentMethod(scope.row.payment_method) }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="150">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="paid_at" label="支付时间" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.paid_at ? formatDate(scope.row.paid_at) : '未支付' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" @click="handleView(scope.row.id)">查看</el-button>
            <el-button size="small" type="primary" @click="handleRefund(scope.row.id)" v-if="scope.row.status === 2">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 订单详情对话框 -->
    <el-dialog :visible.sync="detailDialogVisible" title="订单详情" width="600px">
      <el-form :model="orderDetail" label-width="120px">
        <el-form-item label="订单ID">
          <el-input v-model="orderDetail.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="orderDetail.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="orderDetail.order_no" disabled></el-input>
        </el-form-item>
        <el-form-item label="金额">
          <el-input :value="orderDetail.amount ? `¥${orderDetail.amount / 100}` : ''" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input :value="orderDetail.status ? getOrderStatus(orderDetail.status) : ''" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-input :value="orderDetail.payment_method ? getPaymentMethod(orderDetail.payment_method) : ''" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付单号">
          <el-input v-model="orderDetail.transaction_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="orderDetail.created_at" disabled></el-input>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-input :value="orderDetail.paid_at || '未支付'" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VipOrderList',
  data() {
    return {
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailDialogVisible: false,
      orderDetail: {}
    }
  },
  mounted() {
    this.fetchOrderList()
  },
  methods: {
    fetchOrderList() {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/vip-order/list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.orderList = data.data.list
          this.total = data.data.total
        }
      })
      .catch(() => {
        this.$message.error('获取订单列表失败')
      })
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchOrderList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchOrderList()
    },
    handleView(id) {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/vip-order/detail/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.orderDetail = data.data
          this.detailDialogVisible = true
        }
      })
      .catch(() => {
        this.$message.error('获取订单详情失败')
      })
    },
    handleRefund(id) {
      this.$confirm('确定要退款吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/vip-order/refund/${id}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('退款成功')
            this.fetchOrderList()
          } else {
            this.$message.error(data.message || '退款失败')
          }
        })
        .catch(() => {
          this.$message.error('退款失败')
        })
      })
      .catch(() => {})
    },
    getOrderStatus(status) {
      const statusMap = {
        1: '待支付',
        2: '已支付',
        3: '已退款',
        4: '已取消'
      }
      return statusMap[status] || '未知'
    },
    getPaymentMethod(method) {
      const methodMap = {
        1: '微信支付',
        2: '支付宝',
        3: '银行卡'
      }
      return methodMap[method] || '未知'
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.vip-order-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>